function camelToSnakeCase(key) {
  return key.replace(/([A-Z])/g, "_$1").toLowerCase();
}

function deepCamelToSnake(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    return obj.map(deepCamelToSnake);
  }

  // Handle objects
  const newObj = {};
  for (const camelKey in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, camelKey)) {
      const snakeKey = camelToSnakeCase(camelKey);
      newObj[snakeKey] = deepCamelToSnake(obj[camelKey]);
    }
  }
  return newObj;
}
export { camelToSnakeCase, deepCamelToSnake };
